export const sideTab = {
	delete: "Apagar",
	promotionIs: {
		active: "Ativa",
		inactive: "Inativa",
	},
	popConfirm: {
		title: "Tem certeza que quer apagar a promoção?",
		deletePromotion: "Apagar promoção",
	},
	modalConfirm: {
		title: "Desativar promoção",
		text:
			"Existem eventos em aberto no momento. Ao desativar essa promoção, será necessário refazer o login manualmente em cada um dos aparelhos.",
		additionalText:
			"Ao desativar a promoção, todos os clientes que a receberam não poderão utilizá-las até que ela seja ativada novamente. Além disso, apesar de aparecer na lista de promoções do PDV, a brigada não conseguirá concedê-la a nenhum cliente.",
		infoText: "Digite o nome completo da promoção para confirmar a sua ação",
		errorMessage: "Nome da promoção incorreto",
		inactivePomotion: "Desativar promoção",
		tooltipInactivePromotion:
			"Você deve digitar o nome da promoção exatamente como está cadastrado para concluir a desativação",
		placeholderInactivePromotion: "Digite aqui o nome da promoção",
	},
};
